<template>
  <div class="prepareLessons">
    <div class="topTitle ">
      <span style="cursor: pointer;" @click="goback">返回题库</span> / T1001 计算A+B(新手教程)
    </div>
    <div class="mian">
      <el-tabs v-model="activeName">
        <el-tab-pane label="题单简介" name="first">
          <el-row :gutter="20">
            <el-col :span="16">
              <div>题单简介</div>
            </el-col>
            <el-col :span="8">
              <div class="briefIntroduction_right">
                <ul>

                  <li class="clearfix">
                    <div class="fl">创建者</div>
                    <div class="fr">洛谷</div>
                  </li>
                  <li class="clearfix">
                    <div class="fl">题单类型</div>
                    <div class="fr">官方题单</div>
                  </li>

                </ul>
              </div>

            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="题目列表" name="second">
          <div>
            <el-button type="primary" icon="el-icon-plus">添加问题</el-button>
          </div>
          <el-table :data="tableData" stripe style="width: 100%;margin-top:20px" :header-cell-style="{ color: '#909399' , background: '#f5f7fa'}">
            <el-table-column prop="" label="状态">
            </el-table-column>
            <el-table-column prop="numbh" label="题目编号">
            </el-table-column>
            <el-table-column prop="name" label="问题名称">
              <template slot-scope="scope">
                <span>
                  <el-link>{{scope.row.name}}</el-link>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="time" label="创建时间">
            </el-table-column>

            <el-table-column prop="num1" label="算法标签">
              <template slot-scope="scope">
                <span>
                  <el-tag effect="dark">{{scope.row.num1}}</el-tag>
                </span>
              </template>
            </el-table-column>

          </el-table>
          <div style="margin: 20px; text-align: right">
            <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size" layout="total, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>
</template>
  
  <script>

export default {

  data() {
    return {
      content: '',
      page_no: 1,
      page_size: 20,
      total: 20,
      activeName: 'first',
      tableData: [{
        name: '[入门]顺序结构',
        numbh: 'T1001',
        time: '2022-12:12:11:00',
        num1: '14',

      }]
    }
  },
  methods: {

    handleCurrent(val) {
      this.page_no = val
    },
    goback() {
      this.$router.go(-1)
    }
  }

}
  </script>
  
  <style  lang="scss" scoped>
.prepareLessons {
  margin: 10px;
  min-height: calc(100vh - 120px);
  /* background: #fff; */
  border-radius: 5px;
  overflow: hidden;
}
.briefIntroduction_right {
  padding: 20px;
  padding-top: 0px;
  background: #f9f9f9;
  border-radius: 5px;
  overflow: hidden;
}
.briefIntroduction_right li {
  margin-top: 20px;
  font-size: 16px;
  font-weight: 500;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}
.briefIntroduction_right_bottom {
  margin-top: 20px;
  padding: 20px;
  background: #f9f9f9;

  border-radius: 5px;
  overflow: hidden;
}
.topTitle {
  height: 60px;
  background: #fff;


  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;
  span {
    color: rgba(0, 0, 0, 0.45);
  }
}
.mian {
  margin-top: 10px;
  background: #fff;
  padding: 20px;
}
::v-deep .el-drawer__header > :first-child {
  outline: none;
}
</style>